import currencies from "./currencies";
import dates from "./dates";
import { fetchMessages, getFallbackMessages } from "./utils";

export function getLang() {
    if (!window.lang) {
        // determine lang from query parameter for dev environment
        const match = window.location.search.match(/lang=([^&]+)/);
        return match ? match[1] : "de-DE";
    } else {
        return window.lang;
    }
}

async function getCorrectMessagesOrDefault(lang: string, phraseProject: string) {
    const langUnderscore = lang.replace("-", "_");
    const translationsKey = "translations_" + phraseProject + "_" + langUnderscore;
    const correctMessages =
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        typeof window !== "undefined" ? window[translationsKey] : undefined;
    if (correctMessages) {
        return correctMessages;
    }

    if (phraseProject?.includes("BACKOFFICE")) {
        try {
            const translations = await fetchMessages(phraseProject, langUnderscore);
            if (translations) {
                return translations;
            }
        } catch {
            // Go on returning fallback messages
        }
    }

    try {
        return await getFallbackMessages(lang, phraseProject.toLowerCase());
    } catch {
        // In case one JSON file cannot be loaded, we try fallback to the English one
        try {
            return await getFallbackMessages("en-US", phraseProject.toLowerCase());
        } catch {
            // If also the English fallback translations aren't availabe, we return empty translations
            return {};
        }
    }
}

export type Translations = {
    [translationKey: string]: string;
};

export type PhraseProject = "EXPLORE" | "EVALUATE" | "EXPLORE_BACKOFFICE" | "EMPTY";

export async function getMessagesForAllProjects() {
    const lang = getLang();

    const exploreMessages = (await getCorrectMessagesOrDefault(lang, "EXPLORE")) as Translations;
    const evaluateMessages = (await getCorrectMessagesOrDefault(lang, "EVALUATE")) as Translations;
    const backofficeMessages = (await getCorrectMessagesOrDefault(lang, "EXPLORE_BACKOFFICE")) as Translations;

    const messagesFromAllProjects = {
        EXPLORE: exploreMessages,
        EVALUATE: evaluateMessages,
        EXPLORE_BACKOFFICE: backofficeMessages,
        EMPTY: {} as Translations
    };

    return messagesFromAllProjects;
}

export function getFormats() {
    return { ...currencies, ...dates };
}

declare global {
    interface Window {
        lang: string;
    }
}
